import { FC, useCallback } from 'react';

import { Stack } from '@material-bank/mb-uikit/components/Stack';
import {
  Form,
  FormConsumer,
} from '@material-bank/mb-uikit/shared/components/Form';
import { FormattedMessage } from 'react-intl';
import { BoxProps } from 'theme-ui';

import { EmailField } from './EmailField';
import { PasswordResetFormValues } from './passwordResetForm';
import { useDialogs } from '../../../../components/DialogsController';
import {
  AuthButton,
  AuthFormContainer,
  AuthPageContent,
  useSendPasswordResetLinkMutation,
} from '../../../../modules/auth';
import { uiTranslations } from '../../../../shared/config/i18n';

export interface PasswordResetViewProps extends BoxProps {}

export const PasswordResetView: FC<PasswordResetViewProps> = (props) => {
  const { ...boxProps } = props;

  const { openDialog } = useDialogs();

  const {
    mutate: sendPasswordResetLink,
    isLoading: isPasswordResetLinkSending,
  } = useSendPasswordResetLinkMutation({
    onSuccessResult: (_result, params) => {
      openDialog('passwordResetLinkSent', { email: params.email });
    },
  });

  const onFormSubmit = useCallback(
    (values: PasswordResetFormValues) => {
      sendPasswordResetLink({ email: values.email });
    },
    [sendPasswordResetLink],
  );

  return (
    <AuthPageContent {...boxProps}>
      <AuthFormContainer>
        <Form<PasswordResetFormValues> onSubmit={onFormSubmit}>
          <Stack gap={[4, null, 6]}>
            <EmailField />
            <FormConsumer<PasswordResetFormValues>>
              {({ formState, watch }) => {
                const requiredFieldValues = watch(['email']);
                const areAllRequiredFieldsFilled =
                  requiredFieldValues.every(Boolean);

                return (
                  <AuthButton
                    type="submit"
                    disabled={!areAllRequiredFieldsFilled}
                    loading={
                      formState.isSubmitting || isPasswordResetLinkSending
                    }
                    withSpinner
                  >
                    <FormattedMessage {...uiTranslations.submit} />
                  </AuthButton>
                );
              }}
            </FormConsumer>
          </Stack>
        </Form>
      </AuthFormContainer>
    </AuthPageContent>
  );
};
